/* eslint-disable @next/next/no-img-element */
"use client";

import { FeesType } from "@/common/types";
import AppMarquee from "@/components/AppMarquee";
import AreaChartOverView from "@/components/AreaChartOverView";
import BottomGradientBorder from "@/components/BottomGradientBorder";
import ConnectBankOption from "@/components/ConnectBankOption";
import DelayMounted from "@/components/DelayMounted";
import DynamicFontSize from "@/components/DynamicFontSize";
import DynamicSizeFrame from "@/components/DynamicSizeFrame";
import DynamicSizeIcon from "@/components/DynamicSizeIcon";
import FormatterNumber from "@/components/FormatterNumber";
import LeftGradientBorder from "@/components/LeftGradientBorder";
import ModalLayout from "@/components/ModalLayout";
import PrimaryButton from "@/components/PrimaryButton";
import RequireLogin from "@/components/RequireLogin";
import SectionTitle from "@/components/SectionTitle";
import TwoColumn from "@/components/TwoColumn";
import ValueGroup from "@/components/ValueGroup";
import ValueGroupCenter from "@/components/ValueGroupCenter";
import VerticalGradientText from "@/components/VerticalGradientText";
import WalletOption from "@/components/WalletOption";
import { useAuth } from "@/contexts/Auth";
import { useGlobalData } from "@/contexts/GlobalData";
import { useNotify } from "@/contexts/NotifyProvider";
import { useRealtimeData } from "@/contexts/RealtimeData";
import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import { cn } from "@/lib/utils";
import { Avatar, AvatarGroup, Modal, ModalContent, Skeleton, useDisclosure } from "@nextui-org/react";
import clsx from "clsx";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
const ProcessingRadialBar = dynamic(() => import("@/components/ProcessingRadialBar"));
export interface BoostDataType {
  amount: number;
}
export default function Home() {
  const prefix = "home_";
  const {
    token
  } = useAuth();
  const [selectedLocktime, setSelectedLocktime] = useState<string | undefined>(undefined);
  const noti = useNotify();
  const {
    translate,
    poolStakeSetting,
    getIcon,
    chartData,
    triggerHapticFeedBack,
    getImageFromCMS,
    campaignsData,
    hapticFeedback,
    hideLanding,
    setHideLanding,
    coupponsData,
    runEffectNavigation,
    getLockTimesByContract,
    userWallets,
    investRounds,
    selectedCouponForUse,
    setSelectedCouponForUse,
    userInfo,
    setTransaction,
    transaction,
    couponTabs,
    setCouponTabs,
    appliedCoupon,
    setAppliedCoupon,
    boostAmount,
    setBoostAmount,
    packageInfo
  } = useGlobalData();
  const {
    isOpen: isVerifytModalOpen,
    onOpen: openComingSoonModal,
    onOpenChange: onComingSoonModalChange,
    onClose: closeComingSoonModal
  } = useDisclosure();
  // const {
  //     isOpen: isOpenPresale,
  //     onOpen: onOpenPresale,
  //     onOpenChange: onOpenChangePresale,
  //     onClose: onClosePresale,
  // } = useDisclosure();
  const {
    isOpen: isExprireModalOpen,
    onOpen: openExpireModal,
    onOpenChange: onExpireModalChange,
    onClose: closeExpireModal
  } = useDisclosure();
  // const {
  //     isOpen: isCoupon,
  //     onOpen: openCoupon,
  //     onOpenChange: onCouponChange,
  //     onClose: closeCoupon,
  // } = useDisclosure();
  const {
    packagesData,
    tokensRateState
  } = useRealtimeData();
  const router = useRouter();
  const [fees, setFees] = useState<FeesType | null>(null);
  const [feeIn, setFeeIn] = useState<boolean | undefined>(undefined);
  // const [lockTimesData, setLockTimesData] = useState<
  //     { locktimeDefault: LockTime; locktimes: LockTime[] } | undefined
  // >(undefined);
  const [vestingData, setVestingData] = useState<any>(undefined);
  const [lockTimeSelected, setLockTimeSelected] = useState<any>(undefined);
  const handleHideLanding = () => {
    setHideLanding(true);
  };
  // console.log("🚀 ~ Home ~ lockTimesData:", lockTimesData);

  const {
    isOpen: isOpenConfirm,
    onOpen: onOpenConfirm,
    onOpenChange: onOpenChangeConfirm,
    onClose: onCloseConfirm
  } = useDisclosure();
  const {
    isOpen: isOpenBoostForm,
    onOpen: onOpenBoostForm,
    onOpenChange: onOpenChangeBoostForm,
    onClose: onCloseBoostForm
  } = useDisclosure();
  const {
    isOpen: isOpenAllWallet,
    onOpen: onOpenAllWallet,
    onOpenChange: onOpenChangeAllWallet,
    onClose: onCloseAllWallet
  } = useDisclosure();
  const handleClickClaimInvest = () => {
    try {
      router.push("./manage-package");
      hapticFeedback.impactOccurred("medium");
    } catch (err) {}
  };
  const gotoBranch = () => {
    try {
      hapticFeedback.impactOccurred("medium");
    } catch (e) {
      console.log("🚀 ~ gotoBranch ~ e:", e);
    }
  };
  useEffect(() => {
    if (!isOpenConfirm) {
      // setMessagePopup("");
      setTransaction(undefined);
    }
  }, [isOpenConfirm]);
  const disabledTabs = useMemo(() => {
    if (!campaignsData?.tokenSupports || !campaignsData?.currencies) return [];
    const formatCampaigns = campaignsData?.tokenSupports?.map((item: any) => {
      return item?.contractAddress;
    });
    const formatDisabledCampaigns = campaignsData?.currencies.map((item: any) => {
      return {
        contract_address: item?.contract_address,
        isDisabled: !formatCampaigns.includes(item?.contract_address),
        currency_name: item?.currency_name,
        decimal: item?.currency_name == "USDT" ? 6 : item?.decimal,
        enable: item?.enable
      };
    }).sort((a: any, b: any) => {
      if (!a.isDisabled && b.isDisabled) return -1;
      if (a.isDisabled && !b.isDisabled) return 1;
      return 0;
    });
    return formatDisabledCampaigns?.filter((e: any) => e?.enable);
  }, [campaignsData]);
  useEffect(() => {
    if (!coupponsData) return;
    const tabsTemp = ["all", ...Object.keys(coupponsData).filter(key => key == "couponsUsed" || key == "couponsReceived")].sort((a, b) => {
      if (a == "couponsUsed" && b == "couponsReceived") return 1;
      if (a == "couponsReceived" && b == "couponsUsed") return -1;
      return 0;
    });
    !couponTabs && setCouponTabs(tabsTemp);
  }, [coupponsData]);

  // let availableCast = 0;
  // try {
  //     availableCast = packagesData?.packages?.reduce(
  //         (total: number, item: any) => total + +(item?.isOwner ? item?.availableCast ?? 0 : 0),
  //         0
  //     );
  // } catch (e) {
  //     availableCast = 0;
  // }

  const fakeWallets = [{
    icon: getIcon("tonkeeper"),
    name: "Tonkeeper",
    balance: 12334,
    unit: "$"
  }, {
    icon: getIcon("tonkeeper"),
    name: "Phantom",
    balance: 45,
    unit: "$"
  }, {
    icon: getIcon("tonkeeper"),
    name: "MetaMask",
    balance: 0.12334,
    unit: "$"
  }, {
    icon: getIcon("tonkeeper"),
    name: "Volume",
    balance: 123.34,
    unit: "$"
  }];
  const [selectedWallet, setSelectedWallet] = useState(fakeWallets[0]);
  const [isShowBalance, setIsShowBalance] = useState(true);
  useEffect(() => {
    if (selectedCouponForUse) {
      setAppliedCoupon(selectedCouponForUse);
      // onOpenChangePresale();
    }
    return () => {
      setSelectedCouponForUse(undefined);
    };
  }, []);
  return <>
            <RequireLogin showLoading={!packagesData || !packageInfo || !poolStakeSetting?.current} keyPage="home" data-sentry-element="RequireLogin" data-sentry-source-file="page.tsx">
                {<>
                        {packagesData?.totalPackage <= 0 && !hideLanding && <DefaultPageLayout className="min-h-full relative">
                                <div className="flex flex-col">
                                    <DynamicFontSize fontSize={32}>
                                        <VerticalGradientText className="flex mt-[calc(27/812*100vh)] flex-col animate-fade-up animate-duration-[1200ms]">
                                            <span className="custom-text-color text-secondary font-semibold">
                                                {translate(prefix + "Amplify TBK")}
                                            </span>
                                            <span>{translate(prefix + "Earnings for")}</span>
                                            <span>
                                                <span className="custom-text-color text-secondary">
                                                    {translate(prefix + "Premium")}
                                                </span>{" "}
                                                {translate(prefix + "Prizes")}
                                            </span>
                                        </VerticalGradientText>
                                    </DynamicFontSize>
                                    <DynamicFontSize fontSize={14} className="text-primary italic mt-1 animate-fade-up animate-duration-[1200ms] animate-delay-[300ms]">
                                        {translate(prefix + "$1M Share $50M")}
                                    </DynamicFontSize>
                                    <div className="relative mt-[calc(66/812*100vh)] flex flex-col gap-5 items-end">
                                        <DynamicFontSize fontSize={18}>
                                            <VerticalGradientText className="flex flex-col items-end animate-fade-up animate-duration-[1200ms] animate-delay-[600ms]">
                                                <span>{translate(prefix + "increase your")}</span>
                                                <span>{translate(prefix + "TBK points to")}</span>
                                                <span>
                                                    <span className="custom-text-color text-primary">
                                                        {translate(prefix + "access")}
                                                    </span>
                                                    {translate(prefix + "more")}
                                                </span>
                                                <span>{translate(prefix + "significant and")}</span>
                                                <span className="custom-text-color text-primary">
                                                    {translate(prefix + "luxurious")}
                                                </span>
                                                <span>{translate(prefix + "rewards")}</span>
                                            </VerticalGradientText>
                                        </DynamicFontSize>
                                        <PrimaryButton onClick={handleHideLanding} className="w-fit flex items-center gap-2 !px-4 animate-fade-up animate-duration-[800ms] animate-delay-[500ms]">
                                            <span>{translate("Boost Now")}</span>
                                            <img src={getIcon("forward")} alt="" className="size-3" />
                                        </PrimaryButton>
                                        <div className="w-[calc(300/375*100%)] aspect-square absolute -left-[calc(80/375*100%)] -bottom-[50%] animate-fade-up animate-duration-[1200ms] animate-delay-[500ms]">
                                            <img src={getImageFromCMS(prefix + "rocket")} className="absolute inset-0" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </DefaultPageLayout>}
                        {(packagesData?.totalPackage > 0 || hideLanding) && <DefaultPageLayout className="relative">
                                <div className="flex flex-col gap-3">
                                    <Link href="/setting" onClick={runEffectNavigation}>
                                        <DynamicSizeIcon width={24} icon={getIcon("setting_icon")} className="!block" />
                                    </Link>
                                    <DynamicFontSize fontSize={32}>
                                        <VerticalGradientText className="flex flex-col animate-fade-up animate-duration-[1000ms]">
                                            <span className="custom-text-color text-secondary font-semibold opacity-75">
                                                {translate(prefix + "Boost TBK")}
                                            </span>
                                            {translate(prefix + "to Get") != " " && <span>{translate(prefix + "to Get")}</span>}
                                            {(translate(prefix + "Bigger") != " " || translate(prefix + "Prize") != " ") && <span>
                                                    <span className="custom-text-color text-secondary font-medium opacity-75">
                                                        {translate(prefix + "Bigger")}
                                                    </span>{" "}
                                                    {translate(prefix + "Prize")}
                                                </span>}
                                        </VerticalGradientText>
                                    </DynamicFontSize>
                                    {false && <AppMarquee className="min-h-[43px] animate-fade animate-duration-[3000ms]">
                                            <DynamicFontSize className="flex items-center py-2 text-secondary font-medium" fontSize={16}>
                                                {!!translate(prefix + "The value of TBK has gone up to 0.001 TON") && <span>
                                                        {translate(prefix + "The value of TBK has gone up to 0.001 TON")}
                                                    </span>}
                                                {!!translate(prefix + "The value of TBK has gone up to 0.001 TON") && <div className="size-1 bg-current rounded-full mx-6"></div>}
                                                {!!translate(prefix + "1TBK ~ 0.001 TON") && <span>{translate(prefix + "1TBK ~ 0.001 TON")}</span>}
                                                {!!translate(prefix + "1TBK ~ 0.001 TON") && <div className="size-1 bg-current rounded-full mx-6"></div>}
                                            </DynamicFontSize>
                                        </AppMarquee>}
                                    <LeftGradientBorder className="p-3" background="dark_blue_left_to_right">
                                        <TwoColumn secondColumn={<ValueGroup hideIcon field={translate(prefix + "wTBK Claimed")} value={<FormatterNumber isLessThan start="$" value={packagesData?.totalClaimedWtbk} />} overrideValueClass="!text-secondary"></ValueGroup>} firstColumn={<ValueGroup titleChild={<Link href={"/portfolio"} onClick={gotoBranch}>
                                                            <DynamicFontSize fontSize={11} className={cn("py-0.5 px-2 rounded-md bonus_bg")}>
                                                                <span className={"bonus_text"}>
                                                                    {translate(prefix + "info")}
                                                                </span>
                                                            </DynamicFontSize>
                                                        </Link>} hideIcon field={translate(prefix + "TBK Collected")} value={<FormatterNumber isLessThan value={packagesData?.totalClaimedTbk}
              // start="$"
              />} overrideValueClass="!text-secondary"></ValueGroup>}></TwoColumn>
                                    </LeftGradientBorder>
                                    <TwoColumn className="relative z-10" firstColumn={<BottomGradientBorder className="p-3 h-full flex flex-col gap-3" background="top_to_bottom">
                                                <ValueGroup hideIcon overrideValueClass="!text-secondary" field={translate(prefix + "You are in possession")} value={<FormatterNumber isLessThan value={packagesData?.totalPackage} />} unit={packagesData?.totalPackage ? translate(prefix + (packagesData?.totalPackage > 1 ? "packs" : "pack")) : ""}></ValueGroup>
                                                <ValueGroup hideIcon overrideValueClass="!text-secondary" field={translate(prefix + "Initial Investment")} value={<FormatterNumber isLessThan start="$" value={
              //     packagesData?.packages?.reduce(
              //     (total: number, item: any) =>
              //         total + item.principal * item.rate_usd,
              //     0
              // )
              packageInfo?.total_investment} />}></ValueGroup>
                                                <div className="flex flex-col gap-2">
                                                    <SectionTitle onClickIcon={openComingSoonModal}>
                                                        <span className="flex items-center gap-1">
                                                            <p className="text-[#B1B1B1]">
                                                                {translate(prefix + "Growth ")}
                                                            </p>
                                                            {!!chartData?.length && <p className="text-[#6D6D6D]">
                                                                    {translate(prefix + chartData?.length + " day" + (chartData?.length > 1 ? "s" : ""))}
                                                                </p>}
                                                        </span>
                                                    </SectionTitle>
                                                    <div className="h-[80px] relative">
                                                        <DelayMounted>
                                                            <AreaChartOverView className={clsx("absolute -top-8 -bottom-8")} />
                                                        </DelayMounted>
                                                    </div>
                                                </div>
                                            </BottomGradientBorder>} secondColumn={<BottomGradientBorder className="flex flex-col gap-3 justify-between h-full p-3" background="bottom_to_top">
                                                <DynamicFontSize fontSize={20}>
                                                    <VerticalGradientText className="flex w-full items-start flex-col">
                                                        <span>
                                                            {translate(prefix + "Boost")}{" "}
                                                            <span className="custom-text-color text-secondary">
                                                                {translate(prefix + "TBK")}
                                                            </span>{" "}
                                                            {translate(prefix + "to")}
                                                        </span>
                                                        <span>{translate(prefix + "Get Bigger Prize")}</span>
                                                    </VerticalGradientText>
                                                </DynamicFontSize>
                                                <ValueGroupCenter
              // unit={
              //     availableCast > 0 && (
              //         <>
              //             {availableCast < 0.01 && (
              //                 <span className="relative -top-0.5">{" < "}</span>
              //             )}
              //             <span className="text-[0.6em] opacity-50">{`$`}</span>
              //         </>
              //     )
              // }
              field={translate(prefix + "Interest Available")} value={<FormatterNumber className="flex items-center" start="$" useCompact useCompactOnThousand isLessThan
              // value={availableCast}
              value={packageInfo?.available_reward} unitStyle={{
                fontSize: "0.6em",
                fontWeight: 400
              }} startStyle={{
                fontSize: "0.6em",
                fontWeight: 400
              }} />} des={<span className="flex-inline items-center">
                                                            <span>{translate(prefix + "in unit")}</span>
                                                            <span className="text-secondary">
                                                                {translate(prefix + "units")}
                                                            </span>
                                                        </span>}></ValueGroupCenter>
                                                <PrimaryButton statusKey="manage_page" status={packagesData?.totalPackage > 0 ? "normal" : "disabled"} className="w-full flex items-center gap-2 justify-center" onClick={handleClickClaimInvest}>
                                                    {translate(prefix + "Claim")}
                                                </PrimaryButton>
                                            </BottomGradientBorder>}></TwoColumn>

                                    {userInfo?.permissions.invest_round && <ProcessingRadialBar />}
                                    {investRounds ? <Link href="/presale" className={investRounds?.disableInvest && "pointer-events-none"}>
                                            <LeftGradientBorder onClick={() => {
                {
                  try {
                    // onOpenPresale();
                    hapticFeedback.impactOccurred("medium");
                  } catch (err) {}
                }
              }} background="pink_left_to_right" className={cn("flex items-center p-3 gap-1.5 cursor-pointer", investRounds?.disableInvest && "grayscale-[100%] pointer-events-none")}>
                                                <DynamicSizeIcon icon={getIcon("purple_rocket")} width={14} className="" />
                                                <DynamicFontSize className="purple_text" fontSize={14}>
                                                    {translate(prefix + "Let's get more package")}
                                                </DynamicFontSize>
                                                <DynamicSizeIcon icon={getIcon("right_arrow_setting")} width={11} className="ml-auto" />
                                            </LeftGradientBorder>
                                        </Link> : <Skeleton className="w-full aspect-video rounded-2xl bg-default/10 before:opacity-20" />}
                                </div>
                            </DefaultPageLayout>}
                    </>}

                <Modal isOpen={isOpenAllWallet} placement="bottom" onOpenChange={onOpenChangeAllWallet} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="page.tsx">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]" data-sentry-element="ModalContent" data-sentry-source-file="page.tsx">
                        <ModalLayout className="" boxClassName="max-h-dvh border flex flex-col !pb-0" modalKey="4295e77a-0fac-47d3-937c-97c2b002596ad" title={translate(prefix + "Payment method")} onClose={onCloseAllWallet} data-sentry-element="ModalLayout" data-sentry-source-file="page.tsx">
                            <div className="flex flex-col gap-4 text-white flex-1 overflow-y-scroll !pb-12">
                                <div className="flex flex-col gap-4">
                                    <DynamicFontSize fontSize={16} className="flex items-center gap-2 font-medium leading-[140%]" data-sentry-element="DynamicFontSize" data-sentry-source-file="page.tsx">
                                        {translate(prefix + "balance")}
                                        <DynamicSizeIcon onClick={() => setIsShowBalance(prev => !prev)} width={20} className="cursor-pointer" icon={getIcon("visible")} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="page.tsx" />
                                    </DynamicFontSize>
                                    <div className="flex flex-col items-stretch gap-2 w-full">
                                        {fakeWallets.map((e: any) => <WalletOption layout="full" className="cursor-pointer" onClick={() => setSelectedWallet(e)} key={e.name} icon={e?.icon} name={e.name} balance={e.balance} isSelected={e.name == selectedWallet?.name} showBalance={isShowBalance} unit={e.unit} />)}
                                    </div>
                                    <DynamicFontSize fontSize={16} className="flex items-center gap-2 font-medium leading-[140%]" data-sentry-element="DynamicFontSize" data-sentry-source-file="page.tsx">
                                        {translate(prefix + "More Option")}
                                    </DynamicFontSize>
                                    <Link href="/connect-bank" onClick={() => {
                  try {
                    hapticFeedback.impactOccurred("medium");
                  } catch (err) {}
                }} data-sentry-element="Link" data-sentry-source-file="page.tsx">
                                        <LeftGradientBorder styleBorder={"gradient_bottom_border"} background="pink_left_to_right" className="p-3 rounde" data-sentry-element="LeftGradientBorder" data-sentry-source-file="page.tsx">
                                            <ConnectBankOption icon={getIcon("bank")} name={translate(prefix + "Add a bank account")} des={translate(prefix + "Fast, safe and secure")} data-sentry-element="ConnectBankOption" data-sentry-source-file="page.tsx">
                                                <AvatarGroup data-sentry-element="AvatarGroup" data-sentry-source-file="page.tsx">
                                                    <Avatar classNames={{
                          base: "rounded-md !size-6"
                        }} src={getIcon("r_facebook")} data-sentry-element="Avatar" data-sentry-source-file="page.tsx" />
                                                    <Avatar classNames={{
                          base: "rounded-md !size-6"
                        }} src={getIcon("r_instagram")} data-sentry-element="Avatar" data-sentry-source-file="page.tsx" />
                                                    <Avatar classNames={{
                          base: "rounded-md !size-6"
                        }} src={getIcon("r_threads")} data-sentry-element="Avatar" data-sentry-source-file="page.tsx" />
                                                </AvatarGroup>
                                            </ConnectBankOption>
                                        </LeftGradientBorder>
                                    </Link>
                                    <div className="p-3 border border-[#FFAD40] bg-[#FFAD40]/[0.16] rounded-2xl">
                                        <ConnectBankOption icon={getIcon("wallet")} name={translate(prefix + "Add More Wallet")} des={translate(prefix + "Fast, safe and secure w")} data-sentry-element="ConnectBankOption" data-sentry-source-file="page.tsx">
                                            {" "}
                                            <AvatarGroup data-sentry-element="AvatarGroup" data-sentry-source-file="page.tsx">
                                                <Avatar classNames={{
                        base: "rounded-md !size-6"
                      }} src={getIcon("r_facebook")} data-sentry-element="Avatar" data-sentry-source-file="page.tsx" />
                                                <Avatar classNames={{
                        base: "rounded-md !size-6"
                      }} src={getIcon("r_instagram")} data-sentry-element="Avatar" data-sentry-source-file="page.tsx" />
                                                <Avatar classNames={{
                        base: "rounded-md !size-6"
                      }} src={getIcon("r_threads")} data-sentry-element="Avatar" data-sentry-source-file="page.tsx" />
                                            </AvatarGroup>
                                        </ConnectBankOption>
                                    </div>
                                </div>
                            </div>
                        </ModalLayout>
                    </ModalContent>
                </Modal>
                <Modal isOpen={isVerifytModalOpen} placement="bottom" onOpenChange={onComingSoonModalChange} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="page.tsx">
                    <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]" data-sentry-element="ModalContent" data-sentry-source-file="page.tsx">
                        <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c5467015d0" title={translate(prefix + "Coming soon popup title")} onClose={closeComingSoonModal} className="" data-sentry-element="ModalLayout" data-sentry-source-file="page.tsx">
                            <div className="w-full flex justify-center">
                                <DynamicSizeFrame width={240} className="relative" data-sentry-element="DynamicSizeFrame" data-sentry-source-file="page.tsx">
                                    <div className="absolute -inset-10 items-center flex flex-col gap-4">
                                        <DynamicSizeIcon className="absolute animate-jump-in animate-duration-[800ms] animate-delay-[200ms]" width={300} icon={getIcon(prefix + "coming_soon_icon")} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="page.tsx"></DynamicSizeIcon>
                                    </div>
                                    <div className="absolute -bottom-3  left-1/2 -translate-x-1/2 w-full">
                                        <div className="animate-fade-up animate-duration-[400ms] animate-delay-[500ms] flex flex-col items-center">
                                            <DynamicFontSize fontSize={16} className="text-white" data-sentry-element="DynamicFontSize" data-sentry-source-file="page.tsx">
                                                {translate(prefix + "Coming soon title")}
                                            </DynamicFontSize>
                                            <DynamicFontSize fontSize={16} className="text-description" data-sentry-element="DynamicFontSize" data-sentry-source-file="page.tsx">
                                                {translate(prefix + "Coming soon description")}
                                            </DynamicFontSize>
                                        </div>
                                    </div>
                                </DynamicSizeFrame>
                            </div>
                        </ModalLayout>
                    </ModalContent>
                </Modal>
            </RequireLogin>
        </>;
}